import { usePageTitle, useScrollToTop } from "../hooks";
import { ComiteSection, StorySection } from "../components/sections";
import { ContentSection } from "../components/commons";

const Presentation = () => {
    usePageTitle('Présentation');
    useScrollToTop();
    const presentationContent = (
            <>
                Créé en 2025, <span className="font-semibold italic">Madatlas - Cartes, images et données géographiques
                de Madagascar, de l'Océan Indien et des Afrique</span> est un journal scientifique qui vise à mettre en
                valeur l'image cartographique, iconographiques et graphique, sur Madagascar, l'Océan Indien et les
                Afriques sous toutes ses formes : fixes ou animées, statiques, dynamiques ou interactives, issues de
                travaux manuels, de logiciels d'édition ou de Systèmes d'Information Géographique. La diffusion sous
                forme numérique n'exclu pas le recours à des cartographies non conventionnelles telles que des cartes
                sensibles, des cartes participatives ou contributives, des contre-cartes mais aussi à des dessins, des
                croquis, des photographies, etc., dans la mesure où l'ambition du projet est de rendre compte, dans une
                perspective scientifique, de la diversité et de la richesse des productions iconographiques. Une large
                ouverture thématique est envisagée puisque, au-delà de la place centrale de l'image, c'est l'aire
                géographique qui constituera le dénominateur commun des contributions.
                <br className="my-4" />
                <br className="my-4" />
                Si une grande diversité de types de cartes et de représentations iconographiques pourra être mobilisée,
                la qualité graphique des visuels et la rigueur scientifique des textes qui les accompagnent feront l'
                objet d'une attention particulière. Pour ce faire, la revue est dotée, d'une part, d'un comité
                scientifique doublé d'un comité éditorial et, d'autre part, chaque article est évalué par au moins deux
                relecteurs.
            </>
    );
    return (
        <div className="flex">
            <main className="flex-1">
                <ContentSection
                    title="Le projet éditorial"
                    content={presentationContent}
                    showButton={false}
                    primaryColor="greenlogo"
                    secondaryColor="greenprimary"
                />
                <StorySection />
                <ComiteSection />
            </main>
        </div>
    );
}

export default Presentation;